import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR } from '../../../constants';
import { textStyle } from '../../../helpers/getEmailStyles';

class ReportUserMail extends React.Component {

    static propTypes = {
        content: PropTypes.shape({
            userName: PropTypes.string.isRequired,
            reporterName: PropTypes.string.isRequired,
            reportType: PropTypes.string.isRequired
        })
    };

    render() {
        const { content: { userName, reporterName, reportType, logo, siteName } } = this.props;

        return (
            <Layout>
                <Header color={PRIMARY_COLOR} backgroundColor="#F7F7F7" logo={logo} siteName={siteName} />
                <Body textStyle={textStyle}>
                    <div>
                        Hola Admin,
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        Recibiste una notificación por la infracción de un usuario.
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        {userName} está violando los términos de la plataforma y es denunciado por {reporterName} <br /><br />
                        Violación: {reportType}
                    </div>
                    <EmptySpace height={20} />
                    <EmailSignature siteName={siteName} />
                </Body>
                <Footer siteName={siteName} />
                <EmptySpace height={20} />
            </Layout>
        );
    }

}

export default ReportUserMail;